// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r8-0";